import { quSave } from '@/service/question'
import iconSrc from '@/assets/images/edit/config/ico-numberbox@2x.png'
export default {
  // 对应数据库内类型
  orderById: 140,
  elementType: 'NumberBox',
  elementDesc: '数字题',
  type: 'numberbox',
  // 是否可配置
  config: true,
  // 控件左侧label内容
  title: '数字题',
  placeholder: '数字题',
  isRequired: '1',
  toolbar: {
    edit: true,
    delete: true,
    copy: true,
    config: false
  },
  // 最大长度
  maxLength: 120,
  value: null,
  width: 300,
  paramInt01: '0',
  paramInt02: '100',
  scoreNumType: '1',
  scoreQuType: '1',
  scoreQuParagraph: '1',
  unit: '',
  ruleError: '该字段不能为空',
  saveUrl: '/design/qu-number/ajaxSave.do',
  iconStyle: {
    width: '13px',
    height: '12px',
    background: 'url(' + iconSrc + ')'
  },
  saveFn () {
    return quSave({
      paramInt01: this.paramInt01,
      paramInt02: this.paramInt02,
      scoreQuType: this.scoreQuType,
      scoreNumType: this.scoreNumType,
      scoreQuParagraph: this.scoreQuParagraph,
      unit: this.unit
    }, this)
  },
  saveCb (data) {
    this.paramInt01 = data.paramInt01 || '0'
    this.paramInt02 = data.paramInt02 || '0'
    this.scoreQuType = data.scoreQuType || '1'
    this.scoreNumType = data.scoreNumType || '1'
    this.scoreQuParagraph = data.scoreQuParagraph || '1'
    this.unit = data.unit || ''
  },
  getAnswer () {
    const answer = []
    answer.push({
      belongId: this.belongId,
      belongAnswerId: this.belongAnswerId,
      quId: this.id,
      answserScore: this.value
    })
    return answer
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/NumberBox/config.js